/* eslint-disable no-nested-ternary */
/* eslint-disable max-depth */
import { Form, Row } from "antd";
import BaseInput from "components/base-input";
import { ReactElement, useEffect, useState } from "react";
import { schemaValidate } from "validation/user-register";
import { schemaValidate as schemaValidateUpdate } from "validation/user-update";
import { converSchemaToAntdRule } from "validation";
import { useTranslation } from "react-i18next";
import { TypeCommon } from "models/common";
import BaseSelect from "components/base-select";
import {
  ADMIN_UPDATE_ROLE,
  ALL_ROLE,
  APPROVER_UPDATE_ROLE,
  CREATOR_UPDATE_ROLE,
  FORM_TYPE,
  LOCAL_STORAGE_KEY,
  PLATFORM_UPDATE_ROLE,
  REGEX_KATAKANA,
  REGEX_PHONE_NUMBER,
  ROLE_REGISTER,
  USER_GROUP,
  USER_ROLE,
} from "constants/common.constant";
import { isJsonObject } from "utils/common.util";

const FormRegister = ({
  form,
  onSubmit,
  className,
  userData,
  listAllOrg,
  isEmailExist,
  isUsernameExist,
  setIsUsernameExist,
  setIsEmailExist,
  setIsOpenConfirmReturnModal,
  isPreview = false,
  formType,
  serviceList,
  serviceIds,
}: {
  form: TypeCommon;
  onSubmit: TypeCommon;
  className?: string;
  userData?: TypeCommon;
  listAllOrg?: TypeCommon;
  setIsOpenConfirmReturnModal?: TypeCommon;
  isEmailExist?: TypeCommon;
  isUsernameExist?: TypeCommon;
  setIsUsernameExist?: TypeCommon;
  setIsEmailExist?: TypeCommon;
  isPreview?: boolean;
  formType?: string | null;
  serviceList?: TypeCommon;
  serviceIds?: TypeCommon;
}): ReactElement => {
  const { t } = useTranslation();
  const role = Form.useWatch("role", form);
  const org = Form.useWatch("org", form);
  const servicesValue = Form.useWatch("services", form);
  const [listOrg, setListOrg] = useState<TypeCommon>([]);
  const [roleList, setRoleList] = useState<TypeCommon>([]);
  const [services, setServices] = useState<TypeCommon>([]);
  const [isHidden, setIsHidden] = useState<boolean>(false);
  const [isRequiredOrg, setIsRequiredOrg] = useState<boolean>(false);
  const [isHiddenServices, setIsHiddenServices] = useState<boolean>(true);
  const yupSync = converSchemaToAntdRule(
    (formType === FORM_TYPE.USER_UPDATE ||
      formType === FORM_TYPE.USER_DETAIL) &&
      !isPreview
      ? schemaValidateUpdate
      : schemaValidate,
  );

  const userInfo =
    isJsonObject(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO)) &&
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO) as string);

  const onFieldsChange = (
    changedFields: TypeCommon,
    allFields: TypeCommon,
  ): void => {
    if (changedFields && changedFields?.length > 0) {
      if (changedFields[0]?.name?.includes("role")) {
        const role = changedFields[0]?.value;
        if (role) {
          if (role.includes(USER_GROUP.CREATOR)) {
            const list = listAllOrg?.filter(
              (item: TypeCommon) => !item?.isSummit,
            );
            if (
              userInfo?.group !== USER_GROUP.CREATOR &&
              userInfo?.group !== USER_GROUP.APPROVER
            )
              setListOrg(
                role.includes(USER_ROLE.ROOT)
                  ? list?.filter((item: TypeCommon) => !item?.hasUserRoot)
                  : list,
              );
            setIsHidden(false);
            if (
              role.includes(USER_ROLE.ROOT) ||
              role.includes(USER_ROLE.MANAGER)
            )
              setIsRequiredOrg(false);
            else setIsRequiredOrg(true);
            document?.getElementById("org")?.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          } else if (role.includes(USER_GROUP.APPROVER)) {
            const list = listAllOrg?.filter(
              (item: TypeCommon) => item?.isSummit,
            );
            if (
              userInfo?.group !== USER_GROUP.CREATOR &&
              userInfo?.group !== USER_GROUP.APPROVER
            )
              setListOrg(
                role.includes(USER_ROLE.ROOT)
                  ? list?.filter((item: TypeCommon) => !item?.hasUserRoot)
                  : list,
              );
            setIsHidden(false);
            if (
              role.includes(USER_ROLE.ROOT) ||
              role.includes(USER_ROLE.MANAGER)
            )
              setIsRequiredOrg(false);
            else setIsRequiredOrg(true);
            document?.getElementById("org")?.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          } else if (role.includes(USER_GROUP.ADMIN)) {
            setIsHidden(true);
            if (role.includes(USER_ROLE.ROOT))
              setServices(
                serviceList?.filter(
                  (item: TypeCommon) => item?.ownersRoot?.length === 0,
                ),
              );
            else {
              if (userInfo?.group === USER_GROUP.PLATFORM_ADMIN)
                setServices(serviceList);
              else {
                if (serviceIds?.length > 0) {
                  setServices(
                    serviceList?.filter(
                      (item: TypeCommon) => serviceIds?.includes(item?.value),
                    ),
                  );
                }
              }
            }
            document?.getElementById("services")?.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          } else setIsHidden(true);
          // if (formType === FORM_TYPE.CREATE_USER) {
          //   setIsHiddenServices(!role.startsWith(USER_GROUP.ADMIN));
          // }
        }
      }
      if (changedFields[0]?.name?.includes("org")) {
        const org = listOrg.find(
          (item: TypeCommon) => item.value == changedFields[0]?.value,
        );
        const serviceOrg = org?.servicesDetail;
        if (serviceOrg?.length > 0) {
          setServices(
            serviceList.filter((item: TypeCommon) =>
              serviceOrg.includes(item.value),
            ),
          );
          setIsHiddenServices(false);
          document?.getElementById("services")?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        } else {
          setIsHiddenServices(true);
        }
        form.resetFields(["services"]);
      }
      if (changedFields[0]?.name?.includes("userName")) {
        if (!changedFields[0]?.value) setIsUsernameExist(false);
      }
      if (changedFields[0]?.name?.includes("email")) {
        if (!changedFields[0]?.value) setIsEmailExist(false);
      }
    }
    const index = allFields.findIndex((entry: TypeCommon) => entry?.value);
    if (setIsOpenConfirmReturnModal) {
      if (index > -1) setIsOpenConfirmReturnModal(true);
      else setIsOpenConfirmReturnModal(false);
    }
  };

  useEffect(() => {
    if (userData) {
      const userServices = userData?.services?.map((item: TypeCommon) => {
        return item?.id;
      });
      form.setFieldsValue({
        firstName: userData?.first_name,
        lastName: userData?.last_name,
        firstName_yomi: userData?.first_name_yomi,
        lastName_yomi: userData?.last_name_yomi,
        userName: userData?.username,
        email: userData?.email,
        phoneNumber: userData?.phone_number?.replace("+81", 0),
        role: `${userData?.group}_${userData?.role}`,
        org: userData?.organization_id,
        services: userServices,
      });
      if (
        userData?.group === USER_GROUP.APPROVER ||
        userData?.group === USER_GROUP.CREATOR
      ) {
        setIsHidden(false);
      } else setIsHidden(true);
    }
  }, [userData]);

  useEffect(() => {
    if (formType === FORM_TYPE.REGISTER) {
      const list = listAllOrg?.filter((item: TypeCommon) => !item?.isSummit);
      setListOrg(list);
    } else if (formType === FORM_TYPE.CREATE_USER) {
      if (
        userInfo?.group === USER_GROUP.CREATOR ||
        userInfo?.group === USER_GROUP.APPROVER
      ) {
        const list = listAllOrg?.filter(
          (item: TypeCommon) => item?.value === userInfo?.organization_id,
        );
        setListOrg(list);
      }
    } else if (formType === FORM_TYPE.USER_DETAIL) {
      if (
        userData?.group === USER_GROUP.CREATOR ||
        form.getFieldValue("role")?.includes(USER_GROUP.CREATOR)
      ) {
        setListOrg(listAllOrg?.filter((item: TypeCommon) => !item?.isSummit));
      } else
        setListOrg(listAllOrg?.filter((item: TypeCommon) => item?.isSummit));
    } else setListOrg(listAllOrg);
  }, [listAllOrg]);

  useEffect(() => {
    if (formType === FORM_TYPE.REGISTER) {
      form.setFieldsValue({
        role: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
      });
      setRoleList(ROLE_REGISTER);
    } else if (formType === FORM_TYPE.USER_DETAIL && !isPreview) {
      switch (userData?.group) {
        case USER_GROUP.PLATFORM_ADMIN: {
          if (userData?.role !== USER_ROLE.ROOT)
            setRoleList(PLATFORM_UPDATE_ROLE);
          else setRoleList(ALL_ROLE);
          break;
        }
        case USER_GROUP.ADMIN: {
          if (userData?.role !== USER_ROLE.ROOT) setRoleList(ADMIN_UPDATE_ROLE);
          else setRoleList(ALL_ROLE);
          break;
        }
        case USER_GROUP.APPROVER: {
          if (userData?.role !== USER_ROLE.ROOT)
            setRoleList(APPROVER_UPDATE_ROLE);
          else setRoleList(ALL_ROLE);
          break;
        }
        case USER_GROUP.CREATOR: {
          if (userData?.role !== USER_ROLE.ROOT)
            setRoleList(CREATOR_UPDATE_ROLE);
          else setRoleList(ALL_ROLE);
          break;
        }
      }
    } else if (formType === FORM_TYPE.CREATE_USER) {
      setIsHidden(true);
      switch (userInfo?.group) {
        case USER_GROUP.PLATFORM_ADMIN: {
          if (userInfo?.role === USER_ROLE.ROOT) setRoleList(ALL_ROLE.slice(1));
          else if (userInfo?.role === USER_ROLE.MANAGER)
            setRoleList(ALL_ROLE.slice(2));
          else setRoleList(ALL_ROLE.slice(3));
          break;
        }
        case USER_GROUP.ADMIN: {
          if (userInfo?.role === USER_ROLE.NORMAL)
            setRoleList(ALL_ROLE.slice(6));
          else setRoleList(ALL_ROLE.slice(4));
          break;
        }
        case USER_GROUP.CREATOR: {
          setRoleList(
            ALL_ROLE.filter(
              (item: TypeCommon) =>
                item?.value?.includes(USER_GROUP.CREATOR) &&
                !item?.value?.includes(USER_ROLE.ROOT),
            ),
          );
          break;
        }
        default: {
          setRoleList(
            ALL_ROLE.filter(
              (item: TypeCommon) =>
                item?.value?.includes(USER_GROUP.APPROVER) &&
                !item?.value?.includes(USER_ROLE.ROOT),
            ),
          );
          break;
        }
      }
    } else setRoleList(ALL_ROLE);
    if (isPreview) {
      const org = form.getFieldValue("org");
      if (org?.toString()) setIsHiddenServices(false);
      else setIsHiddenServices(true);
      if (
        form.getFieldValue("role")?.includes(USER_GROUP.CREATOR) ||
        form.getFieldValue("role")?.includes(USER_GROUP.APPROVER)
      ) {
        setIsHidden(false);
      } else setIsHidden(true);
    }
    if (formType === FORM_TYPE.USER_DETAIL && !isPreview) {
      setIsHiddenServices(false);
      const serviceUserDetail = userData?.organization?.services?.map(
        (item: TypeCommon) => {
          return {
            value: item.id,
            label: item.name,
          };
        },
      );
      setServices(serviceUserDetail);
    } else {
      setServices(serviceList);
    }
  }, []);

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
      autoComplete="off"
      onFieldsChange={onFieldsChange}
      className={`${className} w-full`}
    >
      <Row className="w-full !flex flex-col md:flex-row">
        <BaseInput
          name="firstName"
          readOnly={isPreview}
          label={t("login.firstName")}
          disabled={
            formType === FORM_TYPE.USER_DETAIL &&
            !userData?.hasEditInfo &&
            !isPreview
          }
          required={false}
          rule={
            formType === FORM_TYPE.CREATE_USER ||
            formType === FORM_TYPE.USER_DETAIL ||
            userData?.is_azure
              ? undefined
              : [yupSync]
          }
          height={50}
          className="flex-1 md:mr-5"
          maxLength={100}
          isRequired={
            formType !== FORM_TYPE.CREATE_USER &&
            formType !== FORM_TYPE.USER_DETAIL
          }
          showCount
        />
        <BaseInput
          name="lastName"
          readOnly={isPreview}
          label={t("login.lastName")}
          disabled={
            formType === FORM_TYPE.USER_DETAIL &&
            !userData?.hasEditInfo &&
            !isPreview
          }
          required={false}
          rule={
            formType === FORM_TYPE.CREATE_USER ||
            formType === FORM_TYPE.USER_DETAIL ||
            userData?.is_azure
              ? undefined
              : [yupSync]
          }
          height={50}
          className="flex-1"
          isRequired={
            formType !== FORM_TYPE.CREATE_USER &&
            formType !== FORM_TYPE.USER_DETAIL
          }
          maxLength={100}
          showCount={true}
        />
      </Row>
      <Row className="w-full !flex flex-col md:flex-row flex-nowrap">
        <BaseInput
          name="firstName_yomi"
          readOnly={isPreview}
          disabled={
            formType === FORM_TYPE.USER_DETAIL &&
            !userData?.hasEditInfo &&
            !isPreview
          }
          maxLength={100}
          label={
            <Row>
              <Row>{t("login.firstName")}</Row>
              <Row className="text-[10px] opacity-80 mt-[2px] ml-[5px]">
                {t("login.furigana")}
              </Row>
            </Row>
          }
          required={false}
          rule={
            userData?.is_azure
              ? undefined
              : formType === FORM_TYPE.CREATE_USER ||
                  formType === FORM_TYPE.USER_DETAIL
                ? [
                    ({ getFieldValue }: TypeCommon): TypeCommon => ({
                      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                      validator() {
                        if (
                          getFieldValue("firstName_yomi")?.replace(
                            /\s+/g,
                            "",
                          ) &&
                          !getFieldValue("firstName_yomi").match(REGEX_KATAKANA)
                        ) {
                          return Promise.reject(
                            new Error(
                              "名字ーフリガナはカタカナで入力してください。",
                            ),
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]
                : [yupSync]
          }
          height={50}
          isRequired={
            formType !== FORM_TYPE.CREATE_USER &&
            formType !== FORM_TYPE.USER_DETAIL
          }
          showCount={true}
          className="!flex-1 md:mr-5"
        />
        <BaseInput
          name="lastName_yomi"
          readOnly={isPreview}
          disabled={
            formType === FORM_TYPE.USER_DETAIL &&
            !userData?.hasEditInfo &&
            !isPreview
          }
          label={
            <Row>
              <Row>{t("login.lastName")}</Row>
              <Row className="text-[10px] opacity-80 mt-[2px] ml-[5px]">
                {t("login.furigana")}
              </Row>
            </Row>
          }
          required={false}
          rule={
            userData?.is_azure
              ? undefined
              : formType === FORM_TYPE.CREATE_USER ||
                  formType === FORM_TYPE.USER_DETAIL
                ? [
                    ({ getFieldValue }: TypeCommon): TypeCommon => ({
                      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                      validator() {
                        if (
                          getFieldValue("lastName_yomi")?.replace(/\s+/g, "") &&
                          !getFieldValue("lastName_yomi").match(REGEX_KATAKANA)
                        ) {
                          return Promise.reject(
                            new Error(
                              "名前ーフリガナはカタカナで入力してください。",
                            ),
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]
                : [yupSync]
          }
          height={50}
          isRequired={
            formType !== FORM_TYPE.CREATE_USER &&
            formType !== FORM_TYPE.USER_DETAIL
          }
          showCount={true}
          className="!flex-1"
          maxLength={100}
        />
      </Row>
      <BaseInput
        name="userName"
        disabled={
          (formType === FORM_TYPE.USER_UPDATE ||
            formType === FORM_TYPE.USER_DETAIL) &&
          !isPreview
        }
        readOnly={isPreview}
        label={t("login.userName")}
        required={false}
        rule={userData?.is_azure ? undefined : [yupSync]}
        height={50}
        isRequired
        showCount={
          formType === FORM_TYPE.CREATE_USER ||
          formType === FORM_TYPE.USER_UPDATE
        }
        isValueExist={isUsernameExist}
        helpText="ログイン名は既に存在しています。"
        maxLength={100}
      />
      <BaseInput
        name="email"
        readOnly={isPreview}
        disabled={
          formType === FORM_TYPE.USER_DETAIL &&
          !userData?.hasEditInfo &&
          !isPreview
        }
        label={t("login.email")}
        required={false}
        rule={userData?.is_azure ? undefined : [yupSync]}
        isRequired
        showCount={true}
        height={50}
        maxLength={100}
        isValueExist={isEmailExist}
        helpText="メールアドレスは既に存在しています。"
      />
      {(formType === FORM_TYPE.CREATE_USER ||
        formType === FORM_TYPE.REGISTER) && (
        <>
          <BaseInput
            name="password"
            label={t("login.password")}
            height={50}
            required={false}
            rule={[yupSync]}
            type="password"
            isRequired
          />
          <BaseInput
            name="passwordConfirm"
            label={"パスワード再入力"}
            type="password"
            required={false}
            isRequired
            rule={[
              yupSync,
              ({ getFieldValue }: TypeCommon): TypeCommon => ({
                // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                validator() {
                  if (
                    getFieldValue("passwordConfirm")?.replace(/\s+/g, "") &&
                    getFieldValue("passwordConfirm") !==
                      getFieldValue("password")
                  ) {
                    return Promise.reject(
                      new Error(t("login.password-not-match")),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
            height={50}
          />
        </>
      )}
      <BaseInput
        name="phoneNumber"
        readOnly={isPreview}
        disabled={
          formType === FORM_TYPE.USER_DETAIL &&
          !userData?.hasEditInfo &&
          !isPreview
        }
        label={t("login.phoneNumber")}
        required={false}
        rule={
          userData?.is_azure
            ? undefined
            : formType === FORM_TYPE.CREATE_USER ||
                formType === FORM_TYPE.USER_DETAIL
              ? [
                  ({ getFieldValue }: TypeCommon): TypeCommon => ({
                    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                    validator() {
                      if (
                        getFieldValue("phoneNumber")?.replace(/\s+/g, "") &&
                        !getFieldValue("phoneNumber").match(REGEX_PHONE_NUMBER)
                      ) {
                        return Promise.reject(
                          new Error("電話番号を正しく入力してください。"),
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]
              : [yupSync]
        }
        height={50}
        isRequired={
          formType !== FORM_TYPE.CREATE_USER &&
          formType !== FORM_TYPE.USER_DETAIL
        }
        showCount={true}
        maxLength={11}
      />
      <BaseSelect
        name="role"
        label={t("login.role")}
        readOnly={isPreview}
        disabled={
          (formType === FORM_TYPE.USER_UPDATE ||
            (formType === FORM_TYPE.USER_DETAIL &&
              (userData?.role === USER_ROLE.ROOT ||
                // !userData?.hasDelete ||
                !userData?.hasEditRole))) &&
          !isPreview
        }
        isRequired
        allowClear={false}
        options={roleList}
        required={false}
        rule={userData?.is_azure ? undefined : [yupSync]}
        values={role}
        sortSelectedFirst
      />
      {!isHidden && (
        <BaseSelect
          name="org"
          label={"組織／店舗"}
          isRequired={isRequiredOrg || formType === FORM_TYPE.REGISTER}
          disabled={
            formType === FORM_TYPE.USER_DETAIL &&
            !userData?.hasEditInfo &&
            !isPreview
          }
          readOnly={isPreview}
          options={listOrg}
          required={false}
          rule={
            userData?.is_azure
              ? undefined
              : isRequiredOrg || formType === FORM_TYPE.REGISTER
                ? [yupSync]
                : undefined
          }
          values={org}
          sortSelectedFirst
        />
      )}
      {!isHiddenServices && (
        <BaseSelect
          name="services"
          label={"使用できるサービス"}
          multiple
          readOnly={isPreview}
          options={services}
          isRequired
          required={false}
          rule={[
            {
              required: true,
              message: "使用できるサービスを選択してください。",
            },
          ]}
          values={servicesValue}
          sortSelectedFirst
        />
      )}
    </Form>
  );
};

export default FormRegister;
